import { useEffect, useState } from 'react';
import { GET_GB_FEATURE } from '../../constants/endpoints';
import { store } from '../../store';

let promoCache = null;
let promoPromise = null;

export const usePromo = () => {
  const [promos, setPromo] = useState(promoCache || []);
  const [loading, setLoading] = useState(!promoCache);
  const [error, setError] = useState(null);
  const {
    retailerSettings: { name: retailer } = {},
    addresses: {
      shipTo: { zip: shipToZip },
      shippingAddress: { zip: shippingAddressZip },
    },
    returnMethods: { selectedMethod: { carrier, return_method: returnMethod } = {} } = {},
    page: { locale },
  } = store.getState();

  const zipCode = shipToZip || shippingAddressZip;

  useEffect(() => {
    if (!retailer || !zipCode) {
      setLoading(false);
      return;
    }
    if (promoCache) {
      setPromo(promoCache);
      setLoading(false);
      return;
    }

    if (!promoPromise) {
      // This is to prevent multiple requests
      promoPromise = fetch(GET_GB_FEATURE({ feature: 'returns-promotion' }), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          retailer,
          zipCode,
          carrier,
          returnMethod,
          locale,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          promoCache = [data];
          setPromo(promoCache);
          setLoading(false);
        })
        .catch((err) => {
          setError(err);
          setLoading(false);
        });
    } else {
      promoPromise
        .then(() => {
          setPromo(promoCache);
          setLoading(false);
        })
        .catch((err) => {
          setError(err);
          setLoading(false);
        });
    }
  }, []);

  return {
    promos,
    loading,
    error,
    data: {
      zip: zipCode,
      carrier,
      return_method_selected: returnMethod,
      locale,
    },
  };
};
